import React from "react"
import axios from "axios";
import { setup as URI_SETUP } from "../../../../config/api";

const uri_regions = URI_SETUP+"catalog/region";
const uri_hotels = URI_SETUP+"hotel";

class RegionsCities extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            regions                 : [],
            hotels                  : [],
            hotels_unassigned       : [],
            hotels_found            : [],
            region                  : {
                                        _id         : "",
                                        name        : ""
                                    },
            hotel                  : {
                                        _id         : "",
                                        name        : ""
                                    },
            hotel_opened            : "",
            status_region_hotels    : "hide",
            status_region_modal     : "hide",
            region_action           : "new",
            hotel_action            : "add",
            finder_status           : "",
            background_filter       : ""
            }
    }

    componentWillMount(){
        this.getRegions();
        this.getUnassignedHotels();
    }

    // ----------------------- Handlers -----------------------

    handleRegionSelector(region) {
        let self = this;
        
        axios.get(uri_hotels, { 
            params: {
                api_token   : localStorage.getItem("api_token"),
                region_id        : region._id.$oid
            }
        }).then(request => { 
            self.setState({ 
            hotels                  : request.data,
            region                  : region,
            status_region_hotels     : "",
            }) 
        })
    }

    handleHotelSelector(hotel,action) {
        let self = this;
        var qs = require("qs");
        
        const regionToSent = qs.stringify({
            define_region_id: self.state.region._id.$oid,
            action_region:  action
        });
        axios.post(uri_hotels+"/"+hotel, regionToSent)
        .then(request => { 
            self.handleRegionSelector(self.state.region) ;
            self.setState({ 
                hotels_found    : []
                }) 
        })   

    }

    handleEditRegion() {
        let self = this;
        self.setState({ 
            status_region_modal      : "",
            background_filter       : "blur",
            region_action            : "edit"
            })
    }

    handleNewRegion() {
        let self = this;
        self.clearRegion();
        self.setState({ 
            status_region_modal      : "",
            background_filter       : "blur",
            status_region_hotels     : "hide",
            status_hotel_details    : "hide",
            region_action            : "new"
            })
    }

    handleRegionChange = (e) => {
        let region = Object.assign({}, this.state.region);
        region[e.target.name] = e.target.value;
        this.setState({region});
    }

    handleFindHotelChange = (e) => {

        let self = this;
        if (e.target.value.trim()=="") {
            self.setState({ 
                hotels_found             : [],
                finder_status            : ""
                })
        } else {
            axios.get(uri_hotels, { 
                params: {
                    api_token             : localStorage.getItem("api_token"),
                    no_region_like        : e.target.value
                }
            }).then(request => { 
                if(request.data.length>0){
                    self.setState({ 
                        hotels_found             : request.data,
                        finder_status            : "finding"
                        }) 
                }else{
                    self.setState({ 
                        hotels_found             : [],
                        finder_status            : ""
                        }) 
                }

                
                
            })
        }
    }

    handleHotelOpen(id){
        let item_opened = "";
        if(this.state.hotel_opened!=id){
            item_opened = id;
        }
        this.setState({ 
            hotel_opened             : item_opened
            }) 
    }

    // ----------------------- Functions -----------------------

    getRegions(){
        let self = this;
        axios.get(uri_regions, { 
            params: {
                api_token   : localStorage.getItem("api_token")
            }
        }).then(request => { 
            self.setState({ 
                regions                : request.data
            }) 
            
        })
    }

    getUnassignedHotels(){
        let self = this;
        axios.get(uri_hotels, { 
            params: {
                api_token   : localStorage.getItem("api_token"),
                unassigned  : true
            }
        }).then(request => { 
            self.setState({ 
                hotels_unassigned   : request.data
            }) 
            
        })
    }

    clearRegion(){
        let self = this;
        self.setState({ 
            region      : {
                _id         : "",
                name        : ""
            }
            })
    }

    cancelRegion(){
        let self = this;
        self.setState({ 
            status_region_modal    : "hide",
            background_filter        : ""
            })
    }

    onSubmitRegion(e){
        let self = this;
        e.preventDefault();
        var qs = require("qs");

        const regionToSent = qs.stringify({
            name: self.state.region.name
        });
        if(self.state.region_action=="new"){
            axios.post(uri_regions, regionToSent)
                    .then(request => { 
                    })
        }else{
            axios.post(uri_regions+"/"+self.state.region._id.$oid, regionToSent)
            .then(request => { 
            })   

        }

        self.clearRegion();
        self.setState({ 
            status_region_modal      : "hide",
            background_filter       : "",
            status_region_hotels     : "hide",
            status_hotel_details    : "hide"
            })
        
        self.getRegions();
    }
    
    onDragStart = (ev, id) => {
        ev.dataTransfer.setData("id", id);
    }

    onDragOver = (ev) => {
        ev.preventDefault();
    }

    onDrop = (ev, alias_id) => {
       let id = ev.dataTransfer.getData("id");
       var qs = require("qs");
       const valuesToSent = qs.stringify({
            alias_id    : alias_id,
            action      : 'assign_alias'
        });
       axios.post(uri_hotels+"/"+id, valuesToSent)
                    .then(request => {  
                        this.handleRegionSelector(this.state.region);
                        this.getUnassignedHotels();
                    })  
    }

    unassignAlias (id) {
        var qs = require("qs");
        const valuesToSent = qs.stringify({
             action      : 'unassign_alias'
         });
        axios.post(uri_hotels+"/"+id, valuesToSent)
                     .then(request => {  
                        this.handleRegionSelector(this.state.region);
                        this.getUnassignedHotels();
                     })  
     }

    

    // ----------------------- Renders -----------------------


    renderRegions() {
        return <ul>
                    {Object.keys(this.state.regions).map((key, index) => {
                        return (<li key={this.state.regions[key]._id.$oid} onClick={this.handleRegionSelector.bind(this, this.state.regions[key])} >
                                    <div className={(this.state.regions[key]._id.$oid==this.state.region._id.$oid)?"selected":""} >{this.state.regions[key].name}<i className="fa fa-plus-circle clickable"></i></div>
                                </li>);
                        })
                    }
                </ul>   
    }

    renderRegionModal() {
        return <div className="box regular col-md-4 ">
                    <h3>{this.state.region_action=="new"? "NEW REGION": "EDIT REGION" } <i className="fa fa-times-circle" onClick={this.cancelRegion.bind(this)} ></i> </h3>
                    <div className="form-in-box">
                        <form id="region_form" onSubmit={this.onSubmitRegion.bind(this)}>
                            <input type="hidden" name="region" value={(this.state.region._id.$oid==null)? "": this.state.region._id.$oid} /> 
                            <div className="form-row">
                                <div className="col col-md-12">
                                    <label htmlFor="name">{this.state.region_action=="new"? "Add new region": "Edit region name" }</label>
                                    <input type="text" className="form-control" name="name" placeholder="Name" value={(this.state.region.name==null)? "": this.state.region.name} required onChange={e => this.handleRegionChange(e)}  />          
                                </div>
                                <div className="form-row">
                                    <div className="col col-md-6">
                                        <button onClick={this.cancelRegion.bind(this)}>CANCEL</button>   
                                    </div>
                                    <div className="col col-md-6">
                                        <button type="submit" className="blue">SAVE</button> 
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

    }

    renderHotels() {
        return  <ul>
                    <li className="list-header"><div className="label">{this.state.region.name} </div></li>
                    <li className="finder no-padding ">
                    <div className={"input-group " + this.state.finder_status} >
                        <input type="text" className="form-control" name="find_hotels" placeholder="Find Hotels" onChange={e => this.handleFindHotelChange(e)} />
                        <div className="input-group-append">
                            <span className="input-group-text "><i className="fa fa-search"></i></span>
                        </div>
                    </div>
                    {this.renderHotelsFound()} 
                    </li>
                    {Object.keys(this.state.hotels).map((key, index) => {
                        return (<li key={this.state.hotels[key]._id} 
                                    className={"sub-list " + (this.state.hotel_opened==this.state.hotels[key]._id? "" : "collapsed" )}
                                >
                                    <div>
                                        {this.state.hotels[key].name}

                                        <i  className={"clickable fa " + (this.state.hotel_opened==this.state.hotels[key]._id? "fa-angle-up" : "fa-angle-down" )} 
                                            onClick={this.handleHotelOpen.bind(this,this.state.hotels[key]._id)} >
                                        </i>
                                        <i className="fa fa-times-circle remove clickable" onClick={this.handleHotelSelector.bind(this, this.state.hotels[key]._id,'remove')}></i>
                                        <span className= {(this.state.hotels[key].alias_total==0)? "hidden" : "float-right circle-note gray"  } > {this.state.hotels[key].alias_total} </span>

                                    </div>
                                    {this.renderHotelAliasItems(this.state.hotels[key]._id, this.state.hotels[key].alias_list)}
                                </li>);
                        })
                    }
                </ul>   
    }

    renderHotelAliasItems(id,alias_list) {
        return  <ul className="alias-listing" 
                    onDragOver={(e)=>this.onDragOver(e)}
                    onDrop={(e)=>{this.onDrop(e, id)}}>
                        {Object.keys(alias_list).map((key, index) => {
                            return (<li key={alias_list[key]._id} >
                                        <div>{alias_list[key].name}<i className="fa fa-times-circle remove clickable" onClick={this.unassignAlias.bind(this,alias_list[key]._id)} ></i></div>
                                    </li>);
                            }
                        )   
                    }   
                </ul>   
    }

    renderHotelsFound() {
        return  <ul>
                    {Object.keys(this.state.hotels_found).map((key, index) => {
                        return (<li key={this.state.hotels_found[key]._id.$oid} >
                                    <div>{this.state.hotels_found[key].name}
                                        <i className="fa fa-plus-circle clickable"  onClick={this.handleHotelSelector.bind(this,this.state.hotels_found[key]._id,'add')}></i>
                                    </div>
                                </li>);
                        })
                    }
                </ul>   
    }

    renderHotelsUnassigned() {
        return  <ul>
                    <li className="sub-list" ><div> Hotels <i className="fa fa-angle-down"></i>  </div>
                        <ul>
                             {Object.keys(this.state.hotels_unassigned).map((key, index) => {
                                if (this.state.hotels_unassigned[key].magnum_alias == undefined){
                                    return (<li key={this.state.hotels_unassigned[key]._id} className="clickable" draggable="true" onDragStart = {(e) => this.onDragStart(e, this.state.hotels_unassigned[key]._id)} >
                                                <div>{this.state.hotels_unassigned[key].name}</div>
                                            </li>);
                                    }
                                })
                            }
                        </ul>
                    </li>
                        
                </ul>   
    }


    render() {
        return (
            <section>
                <div className={this.state.background_filter}>
                    <div className="head-content "> 
                        <div className="col-md-12 px-2">    
                            <h1>Setup</h1>
                            <h2>REGIONS / CITIES</h2>
                        </div>
                    </div>

                    <div className="col-md-12 no-padding"> 
                        <div className="box regular col-md-4">
                            <h3>REGIONS</h3>
                            <div className="list-in-box">
                                {this.renderRegions()}
                                <button className="blue" onClick={this.handleNewRegion.bind(this)}>NEW +</button>
                            </div>
                        </div>
                        <div className={"box regular col-md-4 " + this.state.status_region_hotels}>
                            <h3>HOTELS</h3>
                            <div className="list-in-box">
                                {this.renderHotels()}
                                <button onClick={this.handleEditRegion.bind(this)}>EDIT</button>
                            </div>
                        </div>
                        <div className={"box regular col-md-4 " + this.state.status_region_hotels}>
                            <h3>PMS</h3>
                            <div className="list-in-box">
                                {this.renderHotelsUnassigned()}
                            </div>
                        </div>

                    </div>
                </div>

                <div className={"modal " + this.state.status_region_modal}> 
                    {this.renderRegionModal()}
                </div>

            </section>
        )
    }

}

export default RegionsCities


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/corporative/RegionsCities.js